import { SentenceFragment } from '../types/sentence-fragment';


export function TitleDefinition(grouping : string) : SentenceFragment[] {
	return [
		{
			key : 'era',
		},
		{
			key : 'color',
		},
		{
			key : 'material',
		},
		{
			key : grouping,
		},
	];
}
